import { V1Table as Table } from '@uhg-abyss/web/ui/Table';
import React, { useState, useEffect } from 'react';
import { useCustomerProfileForm } from './useCustomerProfileForm';
import { Button } from '@uhg-abyss/web/ui/Button';
import { Grid } from '@uhg-abyss/web/ui/Grid';
import { TextInput } from '@uhg-abyss/web/ui/TextInput';
import { useForm } from '@uhg-abyss/web/hooks/useForm';
import { Layout } from '@uhg-abyss/web/ui/Layout';

const GpsGroup = ({ isAdd = false }) => {
  const { editMode } = useCustomerProfileForm();
  const form = useForm();
  const customerData = form.watch('customerDetails.employerGroups');

  const handleClick = () => {
    const lastFourFilled = customerData
      .slice(-4)
      .every((input) => input.employerGroupId.trim() !== '');
    if (lastFourFilled) {
      const newInputs = Array(4)
        .fill(null)
        .map((_, index) => ({
          employerGroupId: '',
          displayBlockNumber: customerData?.length + index,
        }));
      const updatedFormData = [...customerData, ...newInputs];

      form.setValue('customerDetails.employerGroups', updatedFormData);
    } else {
      alert('Please fill in the recent fields before adding more.');
    }
  };

  return (
    <>
      <div
        style={{
          display: 'grid',
          gridTemplateColumns: 'repeat(4, 1fr)',
          gap: '15px',
        }}
      >
        {(editMode || isAdd) &&
          customerData?.map((input, i) => (
            <Layout.Group>
            <TextInput
              key={i}
              model={`customerDetails.employerGroups[${i}].employerGroupId`}
              maxLength={20}
              label=""
              isClearable
            />
            </Layout.Group>
          ))}
      </div>
      {(editMode || isAdd) && (
        <Grid.Col
          css={{
            display: 'flex',
            flexDirection: 'row',
            justifyContent: 'flex-end',
          }}
        >
          <Button size="$sm" css={{ fontSize: '10px' }} onClick={handleClick}>
            New Employer Group
          </Button>
        </Grid.Col>
      )}
      {!(editMode || isAdd) && (
        <div
          style={{
            display: 'grid',
            gridTemplateColumns: 'repeat(4, 1fr)',
            gap: '15px',
          }}
        >
          {customerData?.map((input, i) => (
            <Table.Cell css={{ minWidth: '200px' }} key={i}>
              <strong>{input.employerGroupId}</strong>
            </Table.Cell>
          ))}
        </div>
      )}
    </>
  );
};

export default GpsGroup;
